module.exports = __webpack_public_path__ + "static/media/approved.c442789b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/approved.svg
// module id = 212
// module chunks = 0